// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PErrorOutlinedSvg from "@fishx/icons-svg/es/asn/PErrorOutlined";
import FishxIcon from '../components/FishxIcon';

var PErrorOutlined = function PErrorOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PErrorOutlinedSvg
  }));
};

PErrorOutlined.displayName = 'PErrorOutlined';
export default React.forwardRef(PErrorOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PErrorOutlined.js
// module id = 3362
// module chunks = 0